import { render } from "./OutlinedButton.vue?vue&type=template&id=6fcca017"
import script from "./OutlinedButton.vue?vue&type=script&lang=js"
export * from "./OutlinedButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__